<div class="account-files">
  <div class="row-cols-1 title">
    <h4>Upload files</h4>
  </div>

  <div class="horizontal-divider"></div>

  <div class="table-container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="table-wrapper">
          <table class="table table-borderless bom-table m-0">
            <thead class="table-header">
              <tr class="header">
                <th scope="col" class="table-header-text">
                  <div class="d-flex align-items-center ">
                    <input type="checkbox" class="me-2" style="width: 24px; height: 24px;" [checked]="isAllSelected()" (click)="setSelectionForAll(!isAllSelected())"/>
                    <div class="check-label">
                      <p>Mark All</p>
                    </div>
                  </div>
                </th>
                <th scope="col" class="table-header-text">File Type</th>
                <th scope="col" class="table-header-text">File Size</th>
              </tr>
              <tr class="header-sm">
                <th class="table-header-text">
                  <div class="d-flex align-items-center ">
                    <input type="checkbox" class="me-2" style="width: 24px; height: 24px;" [checked]="isAllSelected()" (click)="setSelectionForAll(!isAllSelected())"/>
                    <div class="check-label">
                      <p >Mark All</p>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr class="content" *ngFor="let file of files;">
                <td scope="row" class="d-block">
                  <div class="d-flex align-items-center">
                    <input type="checkbox" class="me-2" style="width: 24px; height: 24px;" (click)="selectionModel.toggle(file)" [checked]="selectionModel.isSelected(file)"/>
                    <p class="check-label">{{file.name}}</p>
                  </div>
                </td>
                <td data-title="File Type">
                  <div class="type-wrapper">
                    <div class="icon-wrapper pe-2">
                      <div [class]="getFileIconClass(getFileType(file.name))"></div>
                    </div>
                    <p>{{getFileType(file.name) | uppercase}}</p>
                  </div>
                </td>
                <td data-title="File Size">Size: {{ file.size| fileSize }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
